import React from 'react';
import { Dialog } from '@jdcfe/legao';

class ErrorContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      msgs: []
    };

    ErrorContent.single = this;
  }

  push(msg) {
    if (this.state.msgs.indexOf(msg) < 0) {
      this.state.msgs.push(msg);
      this.setState({ msgs: this.state.msgs });
    }
  }

  render() {
    return (
      <div style={{ maxHeight: 150, overflowY: 'auto' }}>
        {this.state.msgs.map((item, i) => (
          <div key={i}>{item}</div>
        ))}
      </div>
    );
  }
}

let isWorking = false;

const push = (msg) => {
  if (isWorking) {
    ErrorContent.single.push(msg);
  } else {
    isWorking = true;

    const a = Dialog.confirm({
      title: '请求错误',
      children: <ErrorContent />,
      actions: [{
        text: "确定",
        onClick: () => {
          a.close();
          isWorking = false;
        },
        className: "",
        styleType: "primary"
      }],
      type: "wrong"
    });

    ErrorContent.single.push(msg);
  }
};

export default {
  push
};